import React, { useState, useEffect, useRef } from 'react';
import customHeaders, { getSpace } from '../../../../common/headers';
import useGeneralStore from '../../../../store/general';
import { ButtonBasic, usePagination, TableBox } from "@lk-gtcom/ecomlab-components";
import { ModalAddFields } from '../Modal/ModalAddFields/ModalAddFields';
import { useShallow } from 'zustand/react/shallow';
import { useDataTable } from '../../../../common/hooks';
import './ContractCRM.scss';

interface ContractCRMProps { }

type PaginatorParams = {
    page?: number;
    limit?: number;
    // Добавьте нужные поля
};

type PaginatorRefType = {
    page?: number;
    limit?: number;
    params: PaginatorParams;
    setTotal?: (total: number) => void;
};

interface TableProps {
    filters: any;
    sort: any;
    total: number;
    loading: boolean;
}

interface SetTableFuncs {
    setLoading: (loading: boolean) => void;
}

const ContractCRM = ({ }: ContractCRMProps) => {
    const selectedSpace = useGeneralStore((state) => state.selectedSpace);
    const {
        isModalContract,
        setIsModalContract,
        currentContract,
        setCurrentContract
    } = useGeneralStore(
        useShallow((state) => ({
            currentContract: state.currentContract,
            isModalContract: state.isModalContract,
            setCurrentContract: state.setCurrentContract,
            setIsModalContract: state.setIsModalContract,
        }))
    );
    const headers = { ...customHeaders, ...getSpace(selectedSpace) };

    const [contractList, setContractList] = useState([])
    const [isModalFields, setIsModalFields] = useState(false)
    const [load, setLoad] = useState(true)

    // Таблица
    const [isTableRequest, setIsTableRequest] = useState(false);
    const paginatorRef = useRef<PaginatorRefType>()
    const [setTable, tableProps, setTableFuncs] = useDataTable(
        paginatorRef.current?.setTotal,
        paginatorRef
    ) as any
    const { setLoading } = setTableFuncs as SetTableFuncs;
    const { loading, sort, filters } = tableProps as TableProps;

    const btns = [
        {
            btn: 'Удалить',
            func: (e: React.MouseEvent) => {
                fetchDeleteContract(e)
            },
        },
    ];

    // Пагинация
    const paginatorCallback = useRef();
    const [
        page,
        limit,
        total,
        setTotal,
        Paginator,
        resetPaginator,
        paginatorTransition,
    ] = usePagination(
        paginatorCallback.current,
        [],
        paginatorRef?.current?.params
    );

    // Получение списка контрактов
    const fetchTableData = (params, abortController = new AbortController()) => {
        let _sort;
        let filtersParam = [];

        if (params) {
            [_sort, filtersParam] = params;
        }

        // Устанавливаем loading в true только если запрос не прерван
        if (!abortController.signal.aborted) {
            setLoading(true);
        }

        let url = ` https://portals.ecomru.ru/api/crm/contracts/table_view`;

        const body = JSON.stringify({
            page: paginatorRef.current?.page,
            limit: paginatorRef.current?.limit,
            filters: Array.isArray(filtersParam) ? filtersParam : filters,
            search: '',
            order_field: _sort?.[0] || sort?.[0],
            order_direction: _sort?.[1] || sort?.[1]
        });

        fetch(url, { body, method: 'POST', headers, signal: abortController.signal })
            .then(async (res) => {
                if (res.ok) {
                    return res.json();
                } else {
                    const err = await res.json();
                    throw new Error(JSON.stringify(err));
                }
            })
            .then((json) => {
                setTable(json);
            })
            .catch((err) => {
                console.error(err);
            })
            .finally(() => {
                if (!abortController.signal.aborted) {
                    setLoading(false);
                }
            });
    };

    // Удаление компании
    const fetchDeleteContract = (id) => {
        let url = ` https://portals.ecomru.ru/api/crm/contracts/${id}`

        fetch(url, { method: 'DELETE', headers })
            .then((res) => res.json())
            .then((json) => {
                console.log('deleted contract')
                setIsTableRequest(!isTableRequest)
            })
            .catch((err) => console.error(err));
    };

    useEffect(() => {
        if (!isModalContract) {
            const abortController = new AbortController();
            fetchTableData([], abortController)
            return () => abortController.abort();
        }
    }, [isTableRequest, isModalContract]);

    const contextMenuArr = [
        {
            label: 'Удалить',
            onClick: (e) => {
                fetchDeleteContract(e?.['id договора']);
            },
        },
    ];

    const onAction = (e) => {
        setCurrentContract(e?.['id договора'])
        setIsModalContract(true)
    }

    return (
        <>
            {isModalFields && <ModalAddFields
                setIsModal={setIsModalFields}
                stringUrl='contracts'
            />}

            <div className={`contract-CRM`}>
                <div className={`contract-CRM__content`}>
                    <div className={`contract-CRM__btn-group`}>
                        <ButtonBasic
                            orange
                            text='+ Добавить договор'
                            onClick={(e) => setIsModalContract(true)}
                        />

                        <ButtonBasic
                            whiteOrange
                            text='+ Создать поля'
                            onClick={(e) => setIsModalFields(true)}
                        />
                    </div>

                    <TableBox
                        {...tableProps}
                        paginator={true}
                        ref={paginatorRef}
                        fetchCallback={fetchTableData}
                        contextMenuArr={contextMenuArr}
                        onAction={onAction}
                    />
                </div>
            </div >
        </>
    );
};

export { ContractCRM };